/* eslint-disable import/prefer-default-export */

export const roles = [
    { value: 'admin', label: 'Admin' },
    { value: 'user', label: 'User' },
    { value: 'readonly', label: 'Read only' },
];
